import { createEvent } from "../../../FormBuilderCore/eventBus/EventSpecification";
import { EventBusEventSource } from "../../../FormBuilderCore/eventBus/EventTypes";

export type EventBusQueryEventProps = {
	fieldName: string
}


export const [queryEventEmitter, queryEventConsumer] =
	createEvent<
		EventBusQueryEventProps,
		EventBusEventSource
	>
	('147a1be4-e334-4c74-b7ca-2e48c24acff4', 'Query Event')

	